import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  styleUrls: ['./mini-table-agreement-info.component.scss'],
  templateUrl: './mini-table-agreement-info.component.html'
})
export class MiniTableAgreementInfoComponent {
  public dataSource: any;
  public displayColumns: string[];
  public title: string;

  constructor(private matDialogRef: MatDialogRef<MiniTableAgreementInfoComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dataSource = data.data;
    this.displayColumns = [
      'from',
      'to',
      'value'
    ];
    this.title = data.title;
  }

  close() {
    this.matDialogRef.close();
  }
}
